export const teams = [
  {
    id: 'nba-lakers',
    name: '洛杉矶湖人',
    short: 'LAL',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '洛杉矶',
    arena: 'Crypto.com 竞技场',
    founded: 1947,
    coach: 'J. 雷迪克',
    color: '#FDB927',
    colorSoft: 'rgba(253,185,39,0.14)',
    rank: 1,
    win: 42,
    loss: 18,
    winRate: '70.0%',
    avgPoints: 116.8,
    avgAllowed: 109.4,
    defRating: 108.2,
    intro: '拥有辉煌历史的传统豪门，队史 17 次夺得总冠军，攻守平衡、内外线火力充足，是本赛季西部冠军的有力争夺者。',
  },
  {
    id: 'nba-warriors',
    name: '金州勇士',
    short: 'GSW',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '旧金山',
    arena: '大通中心',
    founded: 1946,
    coach: 'S. 科尔',
    color: '#1D428A',
    colorSoft: 'rgba(29,66,138,0.14)',
    rank: 3,
    win: 36,
    loss: 24,
    winRate: '60.0%',
    avgPoints: 114.2,
    avgAllowed: 111.8,
    defRating: 110.9,
    intro: '以流畅传切与外线投射闻名的现代篮球代表，三分火力冠绝联盟，主场氛围极具压迫感。',
  },
  {
    id: 'nba-celtics',
    name: '波士顿凯尔特人',
    short: 'BOS',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '波士顿',
    arena: 'TD 花园球馆',
    founded: 1946,
    coach: 'J. 马祖拉',
    color: '#007A33',
    colorSoft: 'rgba(0,122,51,0.14)',
    rank: 2,
    win: 40,
    loss: 20,
    winRate: '66.7%',
    avgPoints: 118.4,
    avgAllowed: 107.6,
    defRating: 106.8,
    intro: '队史 18 次夺冠的历史第一豪门，锋线阵容深厚，攻防两端效率长期位居联盟前列。',
  },
  {
    id: 'nba-nuggets',
    name: '丹佛掘金',
    short: 'DEN',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '丹佛',
    arena: '球馆中心',
    founded: 1967,
    coach: 'M. 马龙',
    color: '#0E2240',
    colorSoft: 'rgba(14,34,64,0.14)',
    rank: 4,
    win: 34,
    loss: 26,
    winRate: '56.7%',
    avgPoints: 113.6,
    avgAllowed: 110.2,
    defRating: 109.5,
    intro: '以内线核心为轴心构建的高效进攻体系，攻传转换流畅，高原主场令客队倍感吃力。',
  },
  {
    id: 'nba-bucks',
    name: '密尔沃基雄鹿',
    short: 'MIL',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '密尔沃基',
    arena: '论坛球馆',
    founded: 1968,
    coach: 'D. 里弗斯',
    color: '#00471B',
    colorSoft: 'rgba(0,71,27,0.14)',
    rank: 5,
    win: 32,
    loss: 28,
    winRate: '53.3%',
    avgPoints: 115.1,
    avgAllowed: 112.9,
    defRating: 111.6,
    intro: '内外线双核驱动的东部劲旅，篮板与禁区得分能力突出，是东部季后赛的常客。',
  },
  {
    id: 'nba-suns',
    name: '菲尼克斯太阳',
    short: 'PHX',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '菲尼克斯',
    arena: '足迹中心',
    founded: 1968,
    coach: 'M. 布登霍尔泽',
    color: '#E56020',
    colorSoft: 'rgba(229,96,32,0.14)',
    rank: 6,
    win: 30,
    loss: 30,
    winRate: '50.0%',
    avgPoints: 112.7,
    avgAllowed: 113.4,
    defRating: 112.8,
    intro: '以中距离与三分为主要得分手段的技术流球队，进攻端火力点众多，节奏明快。',
  },
  {
    id: 'nba-heat',
    name: '迈阿密热火',
    short: 'MIA',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '迈阿密',
    arena: '卡塞雅中心',
    founded: 1988,
    coach: 'E. 斯波尔斯特拉',
    color: '#98002E',
    colorSoft: 'rgba(152,0,46,0.14)',
    rank: 7,
    win: 28,
    loss: 32,
    winRate: '46.7%',
    avgPoints: 109.3,
    avgAllowed: 110.7,
    defRating: 111.2,
    intro: '以铁血防守和团队纪律著称，韧劲十足，常在关键时刻展现出顽强的竞争力。',
  },
  {
    id: 'nba-mavericks',
    name: '达拉斯独行侠',
    short: 'DAL',
    leagueId: 'nba',
    leagueName: 'NBA',
    city: '达拉斯',
    arena: '美国航空中心',
    founded: 1980,
    coach: 'J. 基德',
    color: '#00538C',
    colorSoft: 'rgba(0,83,140,0.14)',
    rank: 8,
    win: 27,
    loss: 33,
    winRate: '45.0%',
    avgPoints: 110.8,
    avgAllowed: 112.1,
    defRating: 112.4,
    intro: '以外线持球核心带动的进攻球队，挡拆配合娴熟，三分爆发力是球队的胜负手。',
  },
  {
    id: 'cba-liaoning',
    name: '辽宁本钢',
    short: '辽宁',
    leagueId: 'cba',
    leagueName: 'CBA',
    city: '沈阳',
    arena: '辽宁体育馆',
    founded: 1953,
    coach: '杨鸣',
    color: '#C8102E',
    colorSoft: 'rgba(200,16,46,0.14)',
    rank: 1,
    win: 38,
    loss: 8,
    winRate: '82.6%',
    avgPoints: 108.5,
    avgAllowed: 96.2,
    defRating: 98.4,
    intro: 'CBA 传统强队，多次问鼎总冠军，阵容深度与本土球员实力均属联盟顶级。',
  },
  {
    id: 'cba-guangdong',
    name: '广东宏远',
    short: '广东',
    leagueId: 'cba',
    leagueName: 'CBA',
    city: '东莞',
    arena: '东莞篮球中心',
    founded: 1993,
    coach: '杜锋',
    color: '#0A3161',
    colorSoft: 'rgba(10,49,97,0.14)',
    rank: 2,
    win: 35,
    loss: 11,
    winRate: '76.1%',
    avgPoints: 106.9,
    avgAllowed: 98.7,
    defRating: 100.1,
    intro: 'CBA 历史上夺冠次数最多的球队之一，快攻反击犀利，青训体系闻名全国。',
  },
  {
    id: 'cba-zhejiang',
    name: '浙江稠州金租',
    short: '浙江',
    leagueId: 'cba',
    leagueName: 'CBA',
    city: '杭州',
    arena: '柯桥体育馆',
    founded: 2003,
    coach: '王世龙',
    color: '#E4002B',
    colorSoft: 'rgba(228,0,43,0.14)',
    rank: 3,
    win: 30,
    loss: 16,
    winRate: '65.2%',
    avgPoints: 104.2,
    avgAllowed: 99.8,
    defRating: 101.3,
    intro: '近年崛起的新兴力量，年轻球员成长迅速，三分投射和跑轰风格颇具观赏性。',
  },
  {
    id: 'cba-xinjiang',
    name: '新疆广汇',
    short: '新疆',
    leagueId: 'cba',
    leagueName: 'CBA',
    city: '乌鲁木齐',
    arena: '红山体育馆',
    founded: 1999,
    coach: '邱彪',
    color: '#1B5E20',
    colorSoft: 'rgba(27,94,32,0.14)',
    rank: 4,
    win: 27,
    loss: 19,
    winRate: '58.7%',
    avgPoints: 101.6,
    avgAllowed: 99.1,
    defRating: 100.8,
    intro: '拥有深厚底蕴的西部劲旅，内线强硬、对抗激烈，主场作战气势如虹。',
  },
  {
    id: 'euro-real',
    name: '皇家马德里',
    short: 'RMB',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    city: '马德里',
    arena: 'WiZink 中心',
    founded: 1931,
    coach: 'C. 马蒂奥',
    color: '#FEBE10',
    colorSoft: 'rgba(254,190,16,0.16)',
    rank: 1,
    win: 24,
    loss: 6,
    winRate: '80.0%',
    avgPoints: 88.6,
    avgAllowed: 78.4,
    defRating: 96.2,
    intro: '欧洲篮球最成功的俱乐部之一，阵容均衡、战术素养极高，常年稳居联赛榜首。',
  },
  {
    id: 'euro-barca',
    name: '巴塞罗那',
    short: 'BAR',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    city: '巴塞罗那',
    arena: '帕劳布劳格拉纳',
    founded: 1926,
    coach: 'R. 格里莫',
    color: '#A50044',
    colorSoft: 'rgba(165,0,68,0.14)',
    rank: 3,
    win: 19,
    loss: 11,
    winRate: '63.3%',
    avgPoints: 85.2,
    avgAllowed: 80.1,
    defRating: 98.5,
    intro: '西班牙豪门，强调阵地进攻与团队传导，青年才俊与外援搭配相得益彰。',
  },
  {
    id: 'euro-olympiacos',
    name: '奥林匹亚科斯',
    short: 'OLY',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    city: '比雷埃夫斯',
    arena: '和平友谊体育馆',
    founded: 1931,
    coach: 'G. 巴佐卡斯',
    color: '#C8102E',
    colorSoft: 'rgba(200,16,46,0.14)',
    rank: 2,
    win: 21,
    loss: 9,
    winRate: '70.0%',
    avgPoints: 86.4,
    avgAllowed: 79.2,
    defRating: 97.1,
    intro: '希腊劲旅，主场气氛火爆，防守强度大，是欧洲赛场上最难攻克的球馆之一。',
  },
  {
    id: 'euro-fener',
    name: '费内巴切',
    short: 'FEN',
    leagueId: 'euro',
    leagueName: 'EuroLeague',
    city: '伊斯坦布尔',
    arena: '乌尔克体育馆',
    founded: 1913,
    coach: 'S. 贾西克维奇',
    color: '#FFCC00',
    colorSoft: 'rgba(255,204,0,0.16)',
    rank: 5,
    win: 16,
    loss: 14,
    winRate: '53.3%',
    avgPoints: 83.7,
    avgAllowed: 82.5,
    defRating: 100.3,
    intro: '土耳其传统豪门，球迷基础庞大，外线投射与整体防守是其立足欧洲的资本。',
  },
  {
    id: 'wnba-aces',
    name: '拉斯维加斯王牌',
    short: 'LVA',
    leagueId: 'wnba',
    leagueName: 'WNBA',
    city: '拉斯维加斯',
    arena: '米切罗布超竞技场',
    founded: 1997,
    coach: 'B. 哈蒙德',
    color: '#000000',
    colorSoft: 'rgba(0,0,0,0.10)',
    rank: 1,
    win: 28,
    loss: 10,
    winRate: '73.7%',
    avgPoints: 89.4,
    avgAllowed: 80.6,
    defRating: 97.8,
    intro: '近年 WNBA 的统治级球队，攻防两端均属顶级，核心阵容经验丰富、配合默契。',
  },
  {
    id: 'wnba-liberty',
    name: '纽约自由人',
    short: 'NYL',
    leagueId: 'wnba',
    leagueName: 'WNBA',
    city: '纽约',
    arena: '巴克莱中心',
    founded: 1997,
    coach: 'S. 布隆代洛',
    color: '#6ECEB2',
    colorSoft: 'rgba(110,206,178,0.16)',
    rank: 2,
    win: 25,
    loss: 13,
    winRate: '65.8%',
    avgPoints: 86.1,
    avgAllowed: 81.9,
    defRating: 99.4,
    intro: '阵容星光熠熠的东部豪门，内外线均衡，是王牌争夺总冠军道路上的最强对手。',
  },
  {
    id: 'ncaa-uconn',
    name: '康涅狄格大学',
    short: 'UCONN',
    leagueId: 'ncaa',
    leagueName: 'NCAA',
    city: '斯托尔斯',
    arena: '甘佩尔馆',
    founded: 1901,
    coach: 'D. 赫利',
    color: '#000E2F',
    colorSoft: 'rgba(0,14,47,0.14)',
    rank: 1,
    win: 30,
    loss: 4,
    winRate: '88.2%',
    avgPoints: 82.6,
    avgAllowed: 66.4,
    defRating: 94.1,
    intro: 'NCAA 男子篮球近年最成功的名校，连续夺冠，阵容深度与战术执行力俱佳。',
  },
  {
    id: 'ncaa-duke',
    name: '杜克大学',
    short: 'DUKE',
    leagueId: 'ncaa',
    leagueName: 'NCAA',
    city: '达勒姆',
    arena: '卡梅隆室内体育馆',
    founded: 1838,
    coach: 'J. 沙伊尔',
    color: '#012169',
    colorSoft: 'rgba(1,33,105,0.14)',
    rank: 4,
    win: 26,
    loss: 8,
    winRate: '76.5%',
    avgPoints: 80.1,
    avgAllowed: 69.8,
    defRating: 96.3,
    intro: 'NCAA 传统名校，常年输送顶级新秀，主场氛围热烈，是疯狂三月的常客。',
  },
  {
    id: 'fiba-usa',
    name: '美国国家队',
    short: 'USA',
    leagueId: 'fiba',
    leagueName: 'FIBA',
    city: '科罗拉多斯普林斯',
    arena: '美国篮球训练中心',
    founded: 1934,
    coach: 'S. 科尔',
    color: '#0A3161',
    colorSoft: 'rgba(10,49,97,0.14)',
    rank: 1,
    win: 8,
    loss: 0,
    winRate: '100%',
    avgPoints: 104.3,
    avgAllowed: 84.6,
    defRating: 96.7,
    intro: '世界篮坛的霸主，阵容由 NBA 顶级球星组成，攻防两端统治力十足。',
  },
  {
    id: 'fiba-serbia',
    name: '塞尔维亚国家队',
    short: 'SRB',
    leagueId: 'fiba',
    leagueName: 'FIBA',
    city: '贝尔格莱德',
    arena: '贝尔格莱德竞技场',
    founded: 1948,
    coach: 'S. 佩西奇',
    color: '#0C4076',
    colorSoft: 'rgba(12,64,118,0.14)',
    rank: 2,
    win: 7,
    loss: 1,
    winRate: '87.5%',
    avgPoints: 96.8,
    avgAllowed: 82.1,
    defRating: 98.2,
    intro: '欧洲传统强队，团队篮球与内线技术出色，是国际赛场上美国队的强劲对手。',
  },
];